import { requestJson } from "./instateamEmployeeApi";

function buildTaskQuery(params = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) searchParams.set(key, value);
  });

  return searchParams.toString() ? `?${searchParams.toString()}` : "";
}

export function getEmployeeTasks(token, params = {}) {
  return requestJson(`/instateam/tasks/employee${buildTaskQuery(params)}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function createEmployeeTask(token, payload) {
  return requestJson("/instateam/tasks/employee", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function updateEmployeeTaskStatus(token, taskId, status) {
  return requestJson(`/instateam/tasks/employee/${taskId}/status`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ status }),
  });
}
